import { OdAuthProvider } from "./authProvider";
import { useAuthProvider } from 'ra-core'
import { useEffect, useState } from "react";
import { AccessTokenClaims, CastedUserManager } from "./odUserManager";
import { parseAccessToken } from "./jwtDecode";

const useIdTokenUser = (): AccessTokenClaims | undefined => {
  const [idTokenUser, setIdTokenUser] = useState<AccessTokenClaims>()
  const authProvider = useAuthProvider() as OdAuthProvider
  const userManager = authProvider.userManager as unknown as CastedUserManager

  useEffect(() => {
    // Todo: somehow the user object didn't populate 'profile' field, will look into later
    // authProvider.userManager.getUser().then(user => setIdTokenUser(user))

    userManager.getUser().then(user => {
      try
      {
        const jwtAt = parseAccessToken<AccessTokenClaims>(user?.access_token || '').payload
        setIdTokenUser(jwtAt)
      }
      catch(err) {
        console.log('unable to read access token')
      }
    })
  }, [setIdTokenUser, userManager])

  return idTokenUser
}

export default useIdTokenUser;
